import { Component, EventEmitter } from '@angular/core';
import { ExibirMenuService } from './pages/shared/exibir-menu.service'
import { Usuario } from './pages/login/usuario.model'
import { DadosAcessoService } from './dadosAcesso.service'
import { isNullOrUndefined } from 'util';
import { NotificationsService } from 'angular2-notifications';
import { empty } from 'rxjs/Observer';
import { AcessoApiService } from './acessoApi.service';
import { error } from 'protractor';
declare var $: any

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  itensVisiveis: boolean = false;
  public iniciais: string
  public usuario: string
  public cod_loja: string
  public ID_OPER: number
  public Acesso: Usuario[]
  public senha: string
  public novaSenha: string
  public senhaConfima: string

  public options = {
    position: ["bottom", "right"],
    timeOut: 5000,
    lastOnBottom: true

  }

  constructor(private exibirMenu: ExibirMenuService, private dadosAcessoService: DadosAcessoService,
    private notificacao: NotificationsService, private acessoAPI: AcessoApiService) { }

  ngOnInit() {
    this.exibirMenu.setItensVisiveis(false);

    this.exibirMenu.mostrarItens.subscribe(
      event => this.setItensVisiveis(event)
    );

    this.dadosAcessoService.emitirNovoAcesso.subscribe(
      data => {
        this.iniciais = data[0].nome_pessoa
        this.usuario = data[0].fantasia_nome
      }
    );
  }

  setItensVisiveis(visibilidade: boolean) {
    this.itensVisiveis = visibilidade;
  }

  alterarSenha() {
    this.cod_loja = this.dadosAcessoService.recuperarLoja()
    if (this.senha === '' || isNullOrUndefined(this.senha)) {
      this.notificacao.error(
        'Campo em branco!',
        'Preencha a senha',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      )
    }
    else if (this.novaSenha === '' || isNullOrUndefined(this.novaSenha)) {
      this.notificacao.error(
        'Campo em branco!',
        'Preencha a nova senha',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      )
    }
    else if (this.senhaConfima === '' || isNullOrUndefined(this.senhaConfima)) {
      this.notificacao.error(
        'Campo em branco!',
        'Confirmação de senha em branco',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      )
    }
    else if (this.novaSenha !== this.senhaConfima) {
      this.notificacao.error(
        'Senhas não conferem!',
        'Favor digitar a mesma senha',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      )
    }
    else {
      this.acessoAPI.alterarSenhaLoja(this.cod_loja, this.senha, this.senhaConfima).subscribe(
        (data: any) => {          
          this.notificacao.success(
            'Sucesso!',
            data, {
              timeOut: 2000,
              showProgressBar: false,
              pauseOnHover: false,
              clickToClose: false,
              maxLength: 2
            }            
          )          

          $("#modalAlterarSenha").modal('hide');
          this.limparCampos();
        }
        ,(error: any) =>{          
          
          this.notificacao.error(
            'Erro!',
            error._body,           
            {
              timeOut: 2000,
              showProgressBar: false,
              pauseOnHover: false,
              clickToClose: false,
              maxLength: 2
            }            
          )
        }
      )
    }
  }

  limparCampos() {
    this.senha = ''
    this.novaSenha = ''
    this.senhaConfima = ''
  }






  // public dadosUsuario(tipo: Usuario[]):void{
  //   this.iniciais = tipo[0].nome_pessoa;
  //   this.usuario = tipo[0].fantasia_nome;
  //   this.ID_OPER = tipo[0].id_oper;
  //   this.cod_loja = tipo[0].cod_loja


  //   this.Acesso = [{nome_pessoa: this. iniciais, fantasia_nome: this.usuario, cod_loja: this.cod_loja, id_oper: this.ID_OPER}]

  //   this.dadosAcessoService.emitirNovoAcesso.subscribe(
  //           function(acesso){
  //             this.iniciais = acesso[0].nome_pessoa
  //             this.usuario = acesso[0].fantasia_nome
  //           }
  //   )

  // }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts